<div class="fingerprint-shell" dir="rtl" [attr.aria-busy]="loading">
  <div class="table-page fingerprint-page-header">
    <header class="header">
      <div class="title-row">
        <button type="button" class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
        <h1 class="title">اثر انگشت رفتاری خودرو</h1>
        <div class="actions">
          <button type="button" class="btn btn-ghost" [disabled]="loading" (click)="loadDashboard()">
            <i class="fa fa-refresh" aria-hidden="true"></i> بروزرسانی
          </button>
        </div>
      </div>
    </header>
  </div>

  <section *ngIf="loading" class="table-page panel fingerprint-loading" role="status" aria-live="polite">
    <div class="loader show">
      <div class="spinner" aria-hidden="true"></div>
      <span>در حال دریافت اطلاعات اثر انگشت خودرو...</span>
    </div>
  </section>

  <main *ngIf="!loading" class="fingerprint-layout">
    <section class="panel hero">
      <app-vehicle-fingerprint-identity [context]="context"></app-vehicle-fingerprint-identity>
    </section>

    <section class="panel quality">
      <app-vehicle-fingerprint-quality [context]="context"></app-vehicle-fingerprint-quality>
    </section>

    <app-vehicle-fingerprint-kpi-panel [context]="context"></app-vehicle-fingerprint-kpi-panel>

    <section class="panel full advanced-electrical">
      <app-vehicle-fingerprint-advanced-electrical [context]="context"></app-vehicle-fingerprint-advanced-electrical>
    </section>

    <section class="panel full electrical-trends">
      <app-vehicle-fingerprint-electrical-trends [context]="context"></app-vehicle-fingerprint-electrical-trends>
    </section>

    <section class="panel half electrical-signature">
      <app-vehicle-fingerprint-electrical-signature [context]="context"></app-vehicle-fingerprint-electrical-signature>
    </section>

    <section class="panel half speed-profile">
      <app-vehicle-fingerprint-speed-profile [context]="context"></app-vehicle-fingerprint-speed-profile>
    </section>
    <section class="panel half speed-trend">
      <app-vehicle-fingerprint-speed-trend [context]="context"></app-vehicle-fingerprint-speed-trend>
    </section>
    <section class="panel half daily-distance">
      <app-vehicle-fingerprint-daily-distance [context]="context"></app-vehicle-fingerprint-daily-distance>
    </section>

    <section class="panel full daily-pattern">
      <app-vehicle-fingerprint-daily-pattern [context]="context"></app-vehicle-fingerprint-daily-pattern>
    </section>

    <section class="panel half daily-activity">
      <app-vehicle-fingerprint-daily-activity [context]="context"></app-vehicle-fingerprint-daily-activity>
    </section>
    <section class="panel half data-coverage">
      <app-vehicle-fingerprint-data-coverage [context]="context"></app-vehicle-fingerprint-data-coverage>
    </section>

    <section class="panel third behavioral-features">
      <app-vehicle-fingerprint-behavioral-features [context]="context"></app-vehicle-fingerprint-behavioral-features>
    </section>
    <section class="panel third geographic-signature">
      <app-vehicle-fingerprint-geographic-signature [context]="context"></app-vehicle-fingerprint-geographic-signature>
    </section>
    <section class="panel third electrical-summary">
      <app-vehicle-fingerprint-electrical-summary [context]="context"></app-vehicle-fingerprint-electrical-summary>
    </section>
  </main>

  <footer class="page-footer">فلیت‌یار · داشبورد اثر انگشت رفتاری خودرو</footer>
</div>
